import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

type StyleProps = {
    teamColor?: string
    marginBottom: number
    headingColor: 'dark' | 'light' | undefined
    bottomBorder: boolean
    capitalize: boolean
  }

  export const TLogo = styled('img')(
    ({ theme }) => ({
        width: '150px',

        [theme.breakpoints.between('sm', 'md')]: {
          maxWidth: '100px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: '80px',
        },
    }))


export const HeadingCon = styled('div')<StyleProps>(
    ({ teamColor, marginBottom, headingColor, bottomBorder, capitalize, theme }) => ({
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      marginTop: theme.spacing(8),
      '&:first-of-type': {
        marginTop: 5,
      },
      '& .headlineTextContainer': {
        display: 'block',
        justifyContent: 'left',
        marginBottom: theme.spacing(marginBottom),
        '& a': {
          color: headingColor === 'light' ? colors.white : colors.text,
          textDecoration: 'none',
          fontSize: fontSizes.small,
          fontWeight: 'bold',
        },
      },
      '& .innerTextContainer': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .headline': {
        fontSize: fontSizes.medium,
        fontWeight: 'normal',
        textTransform: !capitalize ? 'none' : 'uppercase',
        marginBottom: theme.spacing(1),
        color: headingColor === 'light' ? colors.white : colors.text,
      },
  
      // small margin for fav star
      '& .favMargin': {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
      },
  
      '& .viewMoreLink': {
        color: teamColor ?? colors.gray.gray90,
        textDecoration: 'none',
        fontSize: fontSizes.small,
        fontWeight: 'bold',
      },
      '& .headlineDivider': {
        display: !bottomBorder ? 'none' : 'block',
        backgroundColor: teamColor ?? colors.gray.gray90,
        height: 1,
        width: '100%',
      },
    })
  )